import React from 'react';
import { Box, Grid, Menu, MenuItem, Tooltip } from '@mui/material';
import { BsFilterLeft } from 'react-icons/bs';
import { useSearchParams } from 'react-router-dom';

const CategoryFilter = () =>
{
	const [ searchParams, setSearchParams ] = useSearchParams();
	const sortValue = searchParams.get('sort') || 'newest';
	const [ selectedItem, setSelectedItem ] = React.useState(sortValue);
	const [ anchorEl, setAnchorEl ] = React.useState(null);

	const FilterOptions = [
		{ value: 'newest', label: 'Newest', field: 'CREATED_AT', direction: 'DESC' },
		{ value: 'oldest', label: 'Oldest', field: 'CREATED_AT', direction: 'ASC' },
		{ value: 'aToZ', label: 'Alphabetical A to Z', field: 'NAME', direction: 'ASC' },
		{ value: 'zToA', label: 'Alphabetical Z to A', field: 'NAME', direction: 'DESC' }
	];

	const open = Boolean(anchorEl);

	const handleClose = () =>
	{
		setAnchorEl(null);
	};

	const handleMenuItemClick = (option) =>
	{
		// Update the selected item
		setSelectedItem(option.value);

		// Update URL params with sort value, field and direction
		const newParams = new URLSearchParams(searchParams);

		// newParams.set('sort', option.value);
		newParams.set('sortField', option.field);
		newParams.set('sortDirection', option.direction);
		setSearchParams(newParams);

		handleClose();
	};

	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};

	return (
		<Grid item>
			<Tooltip title='Sort' placement='left' arrow>
				<Box
					width={'36px'}
					borderRadius={'var(--pixel6)'}
					border={'1px solid #24a4c4'}
					height={'36px'}
					sx={{ cursor: 'pointer' }}
					onClick={handleClick}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
				>
					<BsFilterLeft fontSize={'var(--pixel20)'} color='var(--primaryColor)'/>
				</Box>
			</Tooltip>
			<Menu
				id='basic-menu'
				anchorEl={anchorEl}
				open={open}
				sx={{ borderBottom: '1px solid red' }}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby' : 'basic-button'
				}}
			>
				{FilterOptions.map((option, index) => (
					<MenuItem
						key={option.value}
						onClick={() => handleMenuItemClick(option)}
						sx={{
							// borderBottom    : index < FilterOptions.length - 1 ? '1px solid #F1F2F6' : 'none',
							backgroundColor : selectedItem === option.value ? '#B4CED466' : 'transparent',
							'&:hover'       : {
								backgroundColor : 'rgba(0, 0, 0, 0.08)'
							}
						}}
					>
						{option.label}
					</MenuItem>
				))}
			</Menu>
		</Grid>
	);
};

export default CategoryFilter;
